import MDButton from 'components/MDButton'
import AddBoxIcon from '@mui/icons-material/AddBox'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDInput from 'components/MDInput'
import Grid from '@mui/material/Grid'
import Select from 'react-select'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { useAppServices } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { useParams } from 'react-router-dom'
import { Checkbox, FormControlLabel } from '@mui/material'
function AddProduct({
  open,
  onClose,
  editData,
  snapshots,
  handleRefresh,
  locations,
  locationsLoader,
}) {
  const Service = useAppServices()
  const { company_id, app_id, app_type } = useParams()
  const [processing, setProcessing] = useState(false)
  const [snapshot, setSnapshot] = useState(editData?.snapshot || false)
  const [workflowLoading, setWorkflowLoading] = useState(false)
  const [location, setLocation] = useState(
    locations?.find((item) => item.value == editData?.location_token?.location_id) || null
  )
  const [installAppWorkflow, setInstallAppWorkflow] = useState(
    editData?.workflows?.installAppWorkflow || null
  )
  const [unInstallAppWorkflow, setUnInstallAppWorkflow] = useState(
    editData?.workflows?.unInstallAppWorkflow || null
  )
  const [workflows, setWorkflows] = useState([])
  const [locationToken, setLocationToken] = useState(editData?.location_token || null)
  const [errors, setErrors] = useState({
    app_name: '',
    app_id: '',
    snapshot: '',
  })
  useEffect(async () => {
    setLocation(
      locations?.find((item) => item.value == editData?.location_token?.location_id) || null
    )
  }, [locations])
  const handleLocation = async (location) => {
    setLocation(location)
    setWorkflowLoading(true)
    setInstallAppWorkflow(null)
    setUnInstallAppWorkflow(null)
    const { response } = await Service.snapshot_onboarding.get_workflows({
      query: `company_id=${company_id}&app_id=${app_id}&location_id=${location.value}`,
    })

    if (response) {
      setWorkflows(
        response?.data?.map((item) => ({
          label: item.name,
          value: item.id,
        }))
      )
      setWorkflowLoading(false)
      setLocationToken(response.location_token)
    }
  }
  const validateForm = (formData) => {
    const newErrors = {}
    let isValid = true

    if (!formData.app_name.trim()) {
      newErrors.app_name = 'App Name is required'
      isValid = false
    }

    if (!formData.app_id.trim()) {
      newErrors.app_id = 'App ID is required'
      isValid = false
    }

    if (app_type === 'snapshot' && !snapshot) {
      newErrors.snapshot = 'Snapshot is required'
      isValid = false
    }

    setErrors(newErrors)
    return isValid
  }
  const showErrorAlert = (message) => {
    Swal.fire({
      icon: 'error',
      title: 'Validation Error',
      text: message,
      confirmButtonColor: '#3085d6',
    })
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)
    const formData = {
      _id: editData?._id,
      app_name: e.target.app_name.value,
      app_id: e.target.app_id.value,
      agency_type: e.target.agency_type.checked,
      sub_account_type: e.target.sub_account_type.checked,
    }

    if (!validateForm(formData)) {
      const firstError = Object.values(errors).find((error) => error)
      if (firstError) {
        showErrorAlert(firstError)
      }
      return
    }
    const payload = {
      ...formData,
      main_app_id: app_id,
      company_id: company_id,
      app_type: app_type,
      // ...(app_type === 'snapshot' && { snapshot: snapshot }),
    }
    // if (installAppWorkflow || unInstallAppWorkflow) {
    //   payload.workflows = {
    //     installAppWorkflow: installAppWorkflow,
    //     unInstallAppWorkflow: unInstallAppWorkflow,
    //   }
    // }
    // if (locationToken) {
    //   payload.location_token = locationToken
    // }
    const { response } = await Service.snapshot_onboarding.update({ payload })
    if (response) {
      onClose()
      setProcessing(false)
      handleRefresh()
    } else {
      setProcessing(false)
    }
  }
  return (
    <MDModal open={open} onClose={onClose}>
      <MDBox>
        <MDTypography component="h1" mb={3} variant="h5">
          App
        </MDTypography>

        <MDBox component="form" onSubmit={handleSubmit} role="form" sx={{ width: 335 }}>
          <Grid item md={12}>
            <MDBox mb={1}>
              <MDTypography variant="button" display="block" gutterBottom>
                App Name
              </MDTypography>
              <MDInput
                defaultValue={editData?.app_name}
                id="bootstrap-input"
                fullWidth
                placeholder="App Name"
                name="app_name"
              />
            </MDBox>
          </Grid>
          <Grid item md={12}>
            <MDBox mb={1}>
              <MDTypography variant="button" display="block" gutterBottom>
                App ID
              </MDTypography>
              <MDInput
                defaultValue={editData?.app_id}
                id="bootstrap-input"
                fullWidth
                placeholder="App ID"
                name="app_id"
              />
            </MDBox>
          </Grid>
          {/* {app_type == 'snapshot' && (
            <Grid item md={12}>
              <MDBox mb={1} sx={{ fontSize: '15px' }}>
                <MDTypography variant="button" display="block" gutterBottom>
                  Select Snapshot
                </MDTypography>
                <Select
                  options={snapshots || []}
                  value={snapshot}
                  onChange={(e) => setSnapshot(e)}
                />
              </MDBox>
            </Grid>
          )} */}
          {/* <Grid item md={12}>
            <MDBox mb={1} sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" display="block" gutterBottom>
                Select Location (for workflows)
              </MDTypography>
              <Select
                isDisabled={locationsLoader}
                isLoading={locationsLoader}
                options={locations}
                value={location}
                onChange={(e) => {
                  handleLocation(e)
                }}
              />
            </MDBox>
          </Grid>
          {location?.value && (
            <>
              <Grid item md={12}>
                <MDBox mb={1} sx={{ fontSize: '15px' }}>
                  <MDTypography variant="button" display="block" gutterBottom>
                    Select Workflow For App Install (optional)
                  </MDTypography>
                  <Select
                    options={workflows}
                    isLoading={workflowLoading}
                    isDisabled={workflowLoading}
                    value={installAppWorkflow}
                    loadingMessage={'Please wait fetching workflows'}
                    onChange={(e) => {
                      setInstallAppWorkflow(e)
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item md={12}>
                <MDBox mb={1} sx={{ fontSize: '15px' }}>
                  <MDTypography variant="button" display="block" gutterBottom>
                    Select Workflow For App UnInstall (optional)
                  </MDTypography>
                  <Select
                    options={workflows}
                    isLoading={workflowLoading}
                    isDisabled={workflowLoading}
                    value={unInstallAppWorkflow}
                    loadingMessage={'Please wait fetching workflows'}
                    onChange={(e) => {
                      setUnInstallAppWorkflow(e)
                    }}
                  />
                </MDBox>
              </Grid>
            </>
          )} */}
          <Grid item md={12} mt={3}>
            <MDBox mb={1}>
              <MDTypography variant="button" display="block" gutterBottom>
                Distribution Type
              </MDTypography>
            </MDBox>
          </Grid>

          <Grid container item md={10}>
            <Grid item xs={5}>
              <MDBox mb={0.5}>
                <FormControlLabel
                  control={<Checkbox name="agency_type" defaultChecked={editData?.agency_type} />}
                  label="Agency"
                />
              </MDBox>
            </Grid>

            <Grid item xs={6}>
              <MDBox mb={0.5}>
                {' '}
                <FormControlLabel
                  control={
                    <Checkbox name="sub_account_type" defaultChecked={editData?.sub_account_type} />
                  }
                  label="Sub-Account"
                />
              </MDBox>
            </Grid>
          </Grid>

          <MDBox>
            <MDButton
              variant="gradient"
              color="info"
              type="submit"
              disabled={processing}
              loading={processing}
              sx={{ mt: 4, mb: 1 }}
              fullWidth
            >
              Update
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </MDModal>
  )
}
const CreateModal = ({ editData, snapshots, handleRefresh, locations, locationsLoader }) => {
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const closeAddProduct = (subscription) => {
    // if (subscription?._id)
    setOpenAddProduct(false)
  }
  return (
    <>
      <MDButton
        sx={{ marginLeft: '4px' }}
        variant="contained"
        color="info"
        size="small"
        onClick={() => setOpenAddProduct(true)}
      >
        Edit
      </MDButton>
      <AddProduct
        open={openAddProduct}
        onClose={closeAddProduct}
        editData={editData}
        locationsLoader={locationsLoader}
        snapshots={snapshots}
        handleRefresh={handleRefresh}
        locations={locations}
      />
    </>
  )
}

export default CreateModal
